const http = require('../lib/httpClient');
const { getChannelId, getCookie, getEcommId } = require('../lib/browserData');

const constants = require('../constants');

const SessionNotFoundError = {
  code: 'GET_ADDRESSES_ERROR_SESSION_NOT_FOUND',
  message: 'Session not found',
};
const GetAddressesError = {
  code: 'GET_ADDRESSES_ERROR',
  message: 'Failed to get addresses',
};

const endpoint = '/s/checkout/v1/users/addresses';

async function catalystGetAddresses(tenantId, catalystBaseUrl = '', additionalInfo = {}) {
  const sessionId = getCookie(constants.COOKIES.SESSION.VALUE);

  if (!sessionId) {
    return { data: undefined, errors: [SessionNotFoundError] };
  }
  const ecommName = getEcommId(tenantId, additionalInfo);
  const isTottus = ecommName.split('-')[0] === constants.ECOMM_NAME_TOTTUS;

  if (!isTottus) {
    return undefined;
  }

  const result = await http.get(`${catalystBaseUrl}${endpoint}`, {
    headers: {
      Authorization: sessionId,
      'x-channel-id': getChannelId(),
      'x-ecomm-name': ecommName,
    },
  });
  const { responseBody } = result || {};
  if (!responseBody) return { data: undefined, errors: [GetAddressesError] };
  const {
    data: { addresses },
  } = responseBody;

  const defaultAddress = addresses.filter((address) => address.isDefaultAddress)[0] || addresses[0];

  return { ...((defaultAddress && defaultAddress[0]) || addresses[0]) };
}

module.exports = catalystGetAddresses;
